/* blanket-compiled.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./blanket-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { N90A } from '@atlaskit/theme/colors';
export var blanketClassName = 'media-card-blanket';
export var fixedBlanketStyles = "background-color: ".concat("var(--ds-blanket, ".concat(N90A, ")"), ";");
var blanketStyles = null;
var fixedBlanketStyle = null;
export var Blanket = function Blanket(props) {
  var isFixed = props.isFixed;
  return /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: ax(["_v564ybtr _kqswstnw _1bsb1osq _4t3i1osq _c71l1osq _p12f1osq _1ltvidpf _154iidpf", isFixed && "_bfhk326j", blanketClassName]),
    "data-testid": "media-card-blanket",
    style: {
      "--_1ox8nit": ix("var(--ds-blanket, ".concat(N90A, ")"))
    }
  });
};
Blanket.displayName = 'Blanket';